module.exports = __webpack_public_path__ + "img/map-options.bc127cc8.png";